import { gsap } from "gsap";

export default function() {
  const catchText = gsap.timeline({ delay: 3 });

  for (let i = 1; i <= 11; i++) {
    let num;
    num = i < 10 ? "0" + i : i;

    gsap.set(
      `.js-fva-catch${num}`,
      { top: 30, opacity: 0 }
    );
  }

  catchText.to(`.js-fva-catch01`, {
    opacity: 1,
    duration: 1,
    top: 0,
    ease: "power4.out"
  });

  for (let i = 2; i <= 11; i++) {
    let num;
    num = i < 10 ? "0" + i : i;

    catchText.to(
      `.js-fva-catch${num}`,
      {
        opacity: 1,
        duration: 1,
        top: 0,
        ease: "power4.out"
      },
      "-=0.9"
    );
  }
}
